import { useAuth0 } from '@auth0/auth0-react';
import { Browser } from '@capacitor/browser';
import { IonButton } from '@ionic/react';

export const MobileLoginButton: React.FC = () => {
  const { loginWithRedirect } = useAuth0();

  const handleLogin = async () => {
    await loginWithRedirect({
      appState: {
        returnTo: '/app'
      },
      async openUrl(url) {
        await Browser.open({ url });
      }
    });
  };

  return <IonButton onClick={handleLogin}>Login</IonButton>;
};
